
Greenmile.EventNotifications = Greenmile.EventNotifications || {};
Greenmile.EventNotifications.Equipment = Greenmile.EventNotifications.Equipment || {};
Greenmile.EventNotifications.Equipment.TableView = Greenmile.EventNotifications.Equipment.TableView || {};

Greenmile.EventNotifications.Equipment.TableView = (function () {

    function EquipmentTableView (equipment, eventId) {

        this.getEquipmentTabContent = function () {

            var grid = new Monet.UI.TableView();

            var organizationDescription  = "",
                equipmentTypeDescription = "";

            if (equipment.organization) {
                organizationDescription = equipment.organization.description;
            }

            if (equipment.equipmentType) {
                equipmentTypeDescription = equipment.equipmentType.description;
            }

            var lines = {
                data: [
                    [new Monet.UI.TableViewCell('TEXT', Monet.I18n.getResourcesByKey('equipment.key')),
                        new Monet.UI.TableViewCell('TEXT', equipment.key)],

                    [new Monet.UI.TableViewCell('TEXT', Monet.I18n.getResourcesByKey('equipment.description')),
                        new Monet.UI.TableViewCell('TEXT', equipment.description)],

                    [new Monet.UI.TableViewCell('TEXT', Monet.I18n.getResourcesByKey('equipment.organization')),
                        new Monet.UI.TableViewCell('TEXT', organizationDescription)],

                    [new Monet.UI.TableViewCell('TEXT', Monet.I18n.getResourcesByKey('equipment.equipmentType')),
                        new Monet.UI.TableViewCell('TEXT', equipmentTypeDescription)]
                ]
            };
            grid.setLines(lines);

            var tableView = grid.render();

            const cellKey = tableView.querySelector(`[cellvalue="${equipment.key}"]`);
            const onclick = () => {

                Monet.Session.TrackEquipmentMaps && (Monet.Session.TrackEquipmentMaps.shouldOpenPopup = true);
                Monet.Session.TrackEquipmentMaps && (Monet.Session.TrackEquipmentMaps.isComingFromEquipmentLink = true);
            };
            const href = `#/TrackEquipmentMapsDisplay/${equipment.id}/event/${eventId}`;
            cellKey.innerHTML = "";
            cellKey.appendChild(grid.generateLink(equipment.key, onclick, href));
            cellKey.style['text-decoration'] = 'underline';

            return tableView;

        };

    }

    return EquipmentTableView;

})();
